function Home(props){
  return (
            <nav id="navigation">
                <div id="navFragmentsContainer">
                    <a href="#reviews" onClick={() => props.setState(1)}><div className="navFragment"><h2>reviews</h2></div></a>
                    <a href="https://ia-ia-ia.world/"><div className="navFragment"><h2>comics</h2><h4>(external site)</h4></div></a>
                    <a href="#bingo" onClick={() => props.setState(2)}><div className="navFragment"><h2>inoue bingo</h2></div></a>
                    <a href="#takahashi-bingo" onClick={() => props.setState(3)}><div className="navFragment"><h2>takahashi bingo</h2></div></a>
                    <a href="#dnd" onClick={() => props.setState(4)}><div className="navFragment"><h2>snaplands update</h2></div></a>
                    <a href="#links" onClick={() => props.setState(5)}><div className="navFragment"><h2>other sites</h2></div></a>
                </div>
            </nav>
            );
}

export default Home;